(()=>{
  const init=(root=document)=>{
    const sections=[...(root.matches?.('[data-story-parallax]')?[root]:[]),...root.querySelectorAll('[data-story-parallax]')];
    sections.forEach(section=>{
      if(section.dataset.parallaxReady)return;
      section.dataset.parallaxReady='true';
      const frame=section.querySelector('[data-story-parallax-frame]');
      const image=frame?.querySelector('img');
      if(!frame||!image||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      let scheduled=false;
      const update=()=>{
        scheduled=false;
        const rect=frame.getBoundingClientRect();
        const offset=(rect.top+rect.height/2-window.innerHeight/2)*-.11;
        image.style.setProperty('--story-parallax-y',`${Math.max(-34,Math.min(34,offset))}px`);
      };
      const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update)}};
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
